export default {"src":"/_next/static/media/Zip.99b47986.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};